import React from "react";
import {
  Body5MediumTypography,
  Body5RegularTypography,
} from "../../primitives/Typography/typographyVariants";
import FlexColumn from "../Layout/FlexColumn/FlexColumn";
import FlexRow from "../Layout/FlexRow/FlexRow";
import Box from "../../primitives/Box/Box";
import { Icon } from "../Icon/Icon";
import { colorPalette } from "../../theme/colors";
import Tags from "../Tags/Tags";
import { BrandCreditsCardProps } from "./BrandCreditsCard.types";
import SparkleCircleImage from "../../../components/SparkleCircleImage/SparkleCircleImage";
import {
  isFlatOrUptoCommission,
  isZeroCommission,
} from "../../../utils/common";
import { SELECT_BY_WISHLINK_BRAND_ID } from "../../utils/constants";

export const BrandCreditsCard: React.FC<BrandCreditsCardProps> = ({
  brandId,
  brandLogo,
  brandName,
  brandCommissionObj,
  brandCredits,
  brandCreditsExpiry,
  onClick,
  isNew,
}) => {
  const brandCreditsExpiryFormatted = (() => {
    if (!brandCreditsExpiry) return "";
    const date = new Date(brandCreditsExpiry);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${day} ${month}, ${year}`;
  })();

  const showNonCommissionable = isZeroCommission(brandCommissionObj);
  const isSelectByWishlinkBrand =
    Number(brandId) === SELECT_BY_WISHLINK_BRAND_ID;
  return (
    <FlexColumn
      onClick={onClick}
      borderColor={colorPalette.info[500]}
      borderRadius="8px"
      alignItems="center"
      pt={12}
      gap={12}
      justifyContent="space-between"
      overflowY="hidden"
      minWidth="154px"
      border={`1px solid ${colorPalette.info[500]}`}
      position="relative"
    >
      {isNew && (
        <Box position="absolute" top="8px" right="8px" zIndex={2}>
          <Tags
            variant="primary"
            label="NEW"
            backgroundColor="background.positive.default"
            color="text.wishlink.on-wishlink"
            uppercase
          />
        </Box>
      )}
      <FlexColumn gap={8} alignItems="center">
        <SparkleCircleImage imgSrc={brandLogo} />
        <FlexRow justifyContent="center" pl={8} pr={8}>
          <Body5MediumTypography textAlign="center">
            {brandName}
          </Body5MediumTypography>
        </FlexRow>
      </FlexColumn>
      <FlexColumn alignItems="center" gap={8}>
        <Body5RegularTypography
          color="text.utilities.text-on-measurement"
          textAlign="center"
          fontFamily="Lexend"
        >
          {/* Upto {brandCommissionInfo}% Commission */}
          {showNonCommissionable
            ? "Non-Commissionable"
            : isFlatOrUptoCommission(brandCommissionObj, false)
            ? // @ts-ignore
              `Flat ${brandCommissionObj?.maxCommission}%`
            : // @ts-ignore
              `Upto ${brandCommissionObj?.maxCommission}%`}{" "}
          Commission
        </Body5RegularTypography>
        <FlexColumn
          backgroundColor={"#BBFDFF"}
          alignItems="center"
          pt={6}
          pb={6}
          gap={4}
        >
          <FlexRow gap={4} justifyContent="center">
            <Icon name="fa-solid fa-coins" size="12" height="16" />
            <Body5RegularTypography>
              {brandCredits} credits
            </Body5RegularTypography>
          </FlexRow>
          {isSelectByWishlinkBrand ? (
            <></>
          ) : (
            <Tags
              label={`Expiry : ${brandCreditsExpiryFormatted}`}
              variant="primary"
              color={colorPalette.popWhite[500]}
              iconColor={colorPalette.popWhite[500]}
              icon="fa-solid fa-clock"
              backgroundColor={"background.danger.default"}
            />
          )}
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  );
};
